import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FastImage from "../../../common/FastImage";
import {participants} from "../../../utils/images";

const ParticipantsBlock = ({participants_no,}) => {
    return (
        <View style={styles.participantsRow}>
            <FastImage
                style={{ width: 18, height: 18,}}
                source={participants()}
            />
            <Text
                style={[
                    globalFontStyle.appFontSmallText,
                    { color: Colors.lightgrey, flexWrap: "wrap", flex: 1 },
                ]}
                numberOfLines={1}
            >
                {participants_no} participants
            </Text>
        </View>
    );
};

export default ParticipantsBlock;

const styles = StyleSheet.create({
    participantsRow: {flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: 5,
        marginBottom: 10
    },
});
